import React from 'react'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import objectFitImages from 'object-fit-images';
import packageJSON from '../../package.json';
import {setToken} from '../store/login';

window.showVersion = () => {
  return packageJSON.version;
}

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
  }

  shouldComponentUpdate () {
    return false
  }

  componentDidMount(){
    objectFitImages();    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let nowait = (urlParams.get('no_wait') != null && urlParams.get('no_wait') != undefined) ? true : false;

    if(urlParams.has('token')) {
      const token = urlParams.get('token');
      setToken(token, true, nowait);
    }
  }

  componentDidUpdate(){
  }

  scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <div style={{ height: '100%' }}>
          <Router history={browserHistory} onUpdate={this.scrollToTop} children={this.props.routes} />
        </div>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js